<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('openTime') }}
    </page-header>
    <div class="mt-4">
      <loading-provider :loading="isLoading">
        <div>
          <horizontal-list>
            <v-card
              v-for="i in weekDayList"
              :key="i.id"
              class="pa-2 px-4"
              elevation="0"
              @click="editOpenTime(i)"
            >
              <div class="d-flex align-center">
                <div>
                  <div
                    :class="dayOfWeek===i.id?'font-weight-black':''"
                    class="text-body-1"
                  >
                    {{ i.name }}
                  </div>
                </div>
                <div class="ml-6">
                  <v-icon size="20">
                    mdi-chevron-right
                  </v-icon>
                </div>
              </div>
              <div>
                <div
                  v-for="x in i.allTypeOpeningTimespan"
                  :key="x.id"
                >
                  <div class="text-caption">
                    {{ x.from }} - {{ x.to }}
                  </div>
                </div>
              </div>
            </v-card>
          </horizontal-list>
          <div class="mt-10">
            <new-add-form
              :day-of-week="dayOfWeek"
              :default-reserve-time="weekDayList"
              :purpose="purpose"
              :show-list="openTimeList"
              :show-reservation="reservationReady"
              @reload="reload"
            />
          </div>
        </div>
      </loading-provider>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import { reservationReady } from '@/model/dataLayer/service/otherService'
import OpeningTime from '@/model/dataLayer/api/takeaway/OpeningTime'
import NewAddForm from '@/views/AadenPages/settings/reserveSetting/fragment/OpenTimeForm.vue'
import WeekDays from '@/model/dataLayer/api/common/WeekDays'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import HorizontalList from '@/views/widget/uiComponent/HorizontalList.vue'
import dayjs from 'dayjs'
import { getReserveSettings } from '@/model/dataLayer/service/reservation/reservation'
import { syncData } from '@/model/dataLayer/api/takeaway/TakeawayManager'

export default {
  name: 'OpenTime',
  components: {
    HorizontalList,
    LoadingProvider,
    NewAddForm,
    PageHeader
  },
  props: {
    purpose: {}
  },
  data: function () {
    return {
      weekDayList: [],
      dayOfWeek: 1,
      openTimeList: [],
      isLoading: false,
      tab: null,
      time: null,
      datePick: false,
      openDateTime: null,
      reservationReady: false
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    editOpenTime (item) {
      this.dayOfWeek = item.id
    },
    async reload () {
      this.isLoading = true
      this.reservationReady = await reservationReady() && (!this.purpose || this.purpose === 'reservation')
      this.openTimeList = (await OpeningTime.getList(true, this.purpose))
      const res = (await getReserveSettings()).weeklySettings.sort(function (a, b) {
        return a.dayOfWeek - b.dayOfWeek
      })
      this.openDateTime = res.map(it => {
        it.dayOfWeek = parseInt(it.dayOfWeek)
        it.weekDay = this.weekDayList.find(item => item.id === it.dayOfWeek)
        it.useTime = dayjs.duration(it.defaultEstimateDiningTime).as('hours')
        return it
      })
      this.weekDayList = []
      const weekday = WeekDays.getList()
      weekday.forEach(it => {
        const reservationInfo = this.openDateTime.find(x => x.dayOfWeek === it.id)
        const res = this.openTimeList.filter(x => x.optweekday[0] === it.name)
        const allTypeOpeningTimespan = res.map(a => {
          return { from: a.startTime, to: a.endTime }
        })
        this.weekDayList.push({ ...it, allTypeOpeningTimespan, ...reservationInfo })
      })
      if (this.purpose === 'takeaway' || this.purpose === 'pickup') {
        try {
          await syncData()
        } catch (e) {
          console.log(e, 'error')
        }
      }
      this.isLoading = false
    }
  }
}
</script>
